import { useEffect, useRef } from 'react';

type NotificationItemProps = {
  id: string;
  children: React.ReactNode;
  onSeen: (id: string) => void;
  hasSeen: boolean;
};

const NotificationItem = ({ id, children, hasSeen, onSeen }: NotificationItemProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasSeen) {
            onSeen(id);
            observer.disconnect();
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
      },
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [id, onSeen]);

  return <div ref={ref}>{children}</div>;
};
export default NotificationItem;
